module.exports = __webpack_public_path__ + "img/FAQ_Lady_1.357b69af.png";